module.exports = __webpack_public_path__ + "img/tutorialRockOn.20984554.svg";